<template>
  <!--  <el-row>-->
  <!--    <el-col :span="24">-->
<!--  <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--&lt;!&ndash;    <el-breadcrumb-item v-for="breadcrumb in blkBreadCrumb" :key="breadcrumb.id" :index=breadcrumb.id>&ndash;&gt;-->
<!--&lt;!&ndash;      {{ breadcrumb.name }}&ndash;&gt;-->
<!--    <el-breadcrumb-item>{{ curBlkstr }}-->
<!--    </el-breadcrumb-item>-->
<!--  </el-breadcrumb>-->

  <!--    </el-col>-->
  <!--  </el-row>-->
  <!--  <el-row style="width: 100%">-->
  <table-view :selectable="selectable" :template-info="templateInfo" :do-verify="true" check-selectablefield="isVerifyable"/>
  <!--  </el-row>-->
</template>

<script>
import axios from "axios";
import TableView from "@/components/tableView";

export default {
  mounted() {
    let _this = this;
    _this.curBlkstr = "";
    this.knowThis();
    console.log(1);
    window.addEventListener('storage', event => {
      if (event.key === 'checkedBlock') {

        if (event.newValue.length > 0) {
          let checkedBlock = JSON.parse(event.newValue);
          let keyidx = 0;
          for (let key in checkedBlock) {
            if (keyidx > 0) {
              _this.curBlkstr += ",";
            }
            _this.curBlkstr += checkedBlock[key].name;
          }
          console.log("watch:",_this.curBlkstr);
        }
      }
    })
  },
  methods: {
    async knowThis() {
      let _this = this;
      console.log(this.$route.name)
      let localIpStr = localStorage.getItem("userLocalIP");
      if (localIpStr == null) localIpStr = "127.0.0.1";
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (jwtSession == null) jwtSession = "";
      await axios({
        url:process.env.VUE_APP_SERVER + "/dataprovider/systemdata/module/route/template/" + `${this.$route.name}`,
        headers: {
          "Authorization": "Bearer " + jwtSession,
          "userIP": localIpStr
        },
        method: 'GET'})
          .then(res => {
            console.log("template");
            console.log(res.data.content)
            _this.tabList=res.data.content;
            _this.templateInfo = _this.tabList.pages[0];
            _this.templateInfo.moduleid=_this.tabList.moduleid;
            _this.templateInfo.modulename=_this.tabList.modulename;
          }).catch(err => {
            console.log(err)
          })
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    uploadFile(file, fileList) {
      console.log(1, file, fileList);
      alert(file);
    }
    // handleChange(file,fileList){
    //   console.log(1,file);
    //   console.log(2,fileList)
    //   console.log(3,this.fileList)
    // }
  },
  data() {
    return {
      templateInfo: {},
      tableData: [],
      blkBreadCrumb: [{id: 0, name: "基础数据综合应用"}, {id: 0, name: "数据应用问题审核"}],
      curBlkstr: "",
      selectable:true,
      menuVisible: false,
      tabList:[]
      // uploadUrl: process.env.VUE_APP_SERVER + "/fileprocesser/upload"
    }
  },
  components: {
    TableView
    // docFileUploader
  },
  watch: {
    $route: {
      handler(val, oldval) {
        console.log("老", val);//新路由信息
        console.log("新", oldval);//老路由信息
        this.knowThis();
      },
      deep: true
    }
  }
}
</script>